import { Navigate } from 'react-router';
import { useUserQuery } from '@/queries/user.query';
import { LoadingScreen } from '../components/LoadingScreen';
import { User } from '@/types/user';
import { permissions } from './permissions';

const getRedirectPathForUser = (user: User): string => {
  if (permissions.enterpriseAdmin(user)) {
    return '/admin/dashboard';
  }

  if (permissions.manageSettings(user)) {
    if (user.org_product_library_config_id) {
      return `/admin/configuration/${user.org_product_library_config_id}`;
    }
    return '/unauthorized';
  }

  return '/login';
};

export const RootRedirector = () => {
  const { data: user, isLoading, isError } = useUserQuery();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError || !user) {
    return <Navigate to="/login" replace />;
  }

  const redirectPath = getRedirectPathForUser(user);
  return <Navigate to={redirectPath} replace />;
};
